import LogoCard from './LogoCard';

export default function LogoResults({
  logos,
  onFinalize,
  onRefine,
  onRegenerate,
  onUploadIcon,
}) {
  return (
    <div className="h-full flex flex-col p-10 overflow-hidden">
      <div className="flex items-center justify-between mb-6 flex-shrink-0 animate-fade-in-up">
        <div className="space-y-1">
          <h3 className="text-xl font-black text-slate-900 dark:text-white tracking-tight">
            Generated Drafts
          </h3>
          <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">Select a concept to refine or download</p>
        </div>
        <div className="flex items-center gap-3">
          {onUploadIcon && (
            <button
              onClick={onUploadIcon}
              className="btn-secondary px-4 py-2 text-xs font-bold border-violet-200 dark:border-violet-500/20 hover:border-violet-500 transition-all"
            >
              <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 16V4m0 0l-3.5 3.5M12 4l3.5 3.5M4 16.5v2.25A2.25 2.25 0 006.25 21h11.5A2.25 2.25 0 0020 18.75V16.5" />
              </svg>
              Upload Own
            </button>
          )}
          <button
            onClick={onRegenerate}
            className="btn-primary px-4 py-2 text-xs font-bold shadow-lg shadow-violet-500/25"
          >
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>
            Fresh Set
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-center min-h-0 overflow-y-auto custom-scrollbar">
        <div className="grid grid-cols-2 gap-4 w-full max-w-lg mx-auto">
          {logos.map((logo, index) => (
            <div
              key={logo.id}
              className="animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'both' }}
            >
              <LogoCard
                logo={logo}
                onFinalize={onFinalize}
                onRefine={onRefine}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
